/**
 * Subscription tier ordering. Mirrors apps/shared/permissions.py::RequiresTier.TIER_ORDER
 * (and the module registry's `tier_min`, which the backend sends per module, so only the
 * ORDER lives here, never which module needs which tier).
 */
export const TIER_ORDER = { basic: 0, professional: 1, enterprise: 2 };

// Same alias the backend applies in normalize_subscription_tier: trials get full
// professional access during onboarding.
const TIER_ALIASES = { trial: 'professional' };

export const normalizeTier = (tier) => {
  if (!tier) return null;
  const value = String(tier).trim().toLowerCase();
  return TIER_ALIASES[value] || value;
};

/**
 * True when `currentTier` satisfies `requiredTier`. Fails OPEN when either side is
 * unknown (subscription not fetched yet, module without a tier): the backend's
 * RequiresTier is the real enforcement, this only decides what the UI shows.
 */
export const tierMeets = (currentTier, requiredTier) => {
  const current = TIER_ORDER[normalizeTier(currentTier)];
  const required = TIER_ORDER[normalizeTier(requiredTier)];
  if (current === undefined || required === undefined) return true;
  return current >= required;
};
